import React from "react";
import { Stack } from "@mui/material";

import { UsersHookFormSelect } from "../../components";
import { useUserHookFormList } from "../../components/UsersHookFormSelect";
import { useFormContext } from "react-hook-form";
import { useScannerHelper } from "../../helpers";

const employeeIdRegex = /^[A-Z]{2}\d{4}$/;

const OutboundServiceOrderContent = ({ isLoading }) => {
  const { users } = useUserHookFormList();
  const { setValue } = useFormContext();

  const onScanEmployee = (barcode) => {
    const employeeIdMatch = employeeIdRegex.test(barcode);
    if (employeeIdMatch) {
      const user = users?.find((u) => u?.employeeId === barcode);
      if (user?.id) setValue("userId", user.id);
      return;
    }
  };

  useScannerHelper(onScanEmployee);

  return (
    <Stack direction="row" gap="15px" width="100%">
      <UsersHookFormSelect
        name="userId"
        label="Employee"
        // locationId={locationId}
        disabled={isLoading}
        required
      />
    </Stack>
  );
};

export default OutboundServiceOrderContent;
